export default __webpack_public_path__ + "static/media/2.05c0f7cf.png";